import React from "react";
import { ArrowUpRight } from "lucide-react";
import { MaskedReveal, FadeUp } from "@/components/motion/Reveal";
import { CLIENTS } from "@/data/site";

function ClientItem({ c }) {
  const inner = (
    <span className="group inline-flex items-center gap-4">
      <span className="serif italic text-3xl md:text-5xl text-[hsl(var(--foreground))]/85 group-hover:text-gold transition-colors duration-500 whitespace-nowrap">
        {c.name}
      </span>
      {c.url && <ArrowUpRight className="h-5 w-5 text-gold opacity-40 group-hover:opacity-100 transition-opacity" />}
    </span>
  );
  return c.url ? (
    <a href={c.url} target="_blank" rel="noreferrer" className="shrink-0">{inner}</a>
  ) : (
    <span className="shrink-0">{inner}</span>
  );
}

export default function Clients() {
  // repeat clients so the strip is dense enough to loop seamlessly
  const repeated = [...CLIENTS, ...CLIENTS, ...CLIENTS, ...CLIENTS];

  const strip = (
    <div className="flex items-center gap-16 pr-16 whitespace-nowrap">
      {repeated.map((c, i) => (
        <span key={i} className="flex items-center gap-16">
          <ClientItem c={c} />
          <span className="text-gold text-2xl md:text-3xl">✦</span>
        </span>
      ))}
    </div>
  );

  return (
    <section className="relative py-24 md:py-32 bg-[hsl(var(--ivory-deep))] overflow-hidden" data-testid="clients">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 mb-14">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="mono text-xs uppercase tracking-[0.32em] text-gold mb-6">Chapter 05 · Clientele</div>
            <MaskedReveal
              as="h2"
              className="serif text-5xl md:text-7xl leading-[0.96]"
              lines={["Trusted by leading", <em key="l" className="italic text-gold">businesses.</em>]}
            />
          </div>
          <FadeUp delay={0.2} className="max-w-sm text-[hsl(var(--muted-foreground))] text-[15px] leading-relaxed">
            A selection of companies that rely on Helkar &amp; Associates for corporate advisory, contracts and dispute resolution.
          </FadeUp>
        </div>
      </div>

      {/* Left-to-right scrolling strip. Change animationDuration to adjust: higher = slower. */}
      <div className="marquee-hover relative py-8 border-y hairline" data-testid="clients-marquee">
        <div className="marquee-track flex w-max" style={{ animationDuration: "80s" }}>
          {strip}
          {strip}
        </div>
        {/* soft edge fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 md:w-40 bg-gradient-to-r from-[hsl(var(--ivory-deep))] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 md:w-40 bg-gradient-to-l from-[hsl(var(--ivory-deep))] to-transparent" />
      </div>

      <div className="mx-auto max-w-[1400px] px-6 md:px-10 mt-8">
        <FadeUp delay={0.3} className="text-xs text-[hsl(var(--muted-foreground))]">
          Client names shown with consent. Representation is subject to confidentiality obligations.
        </FadeUp>
      </div>
    </section>
  );
}
